import {
  Calendar04Icon,
  CalendarClockIcon,
  CalendarX01Icon,
} from '@hugeicons-pro/core-solid-rounded';

export const DUE_DATE_ICONS = {
  future: Calendar04Icon,
  today: CalendarClockIcon,
  past: CalendarX01Icon,
};

export const MY_TASKS_TABS = ['today', 'assigned', 'created'] as const;

export const TASK_STATUS_VALUES = ['open', 'in_progress', 'closed'] as const;

export const MAX_TASK_ASSIGNEES = 3;

export const CLOSURE_TEXT = {
  resolved: { en: 'Resolved', nb: 'Løst' },
  irrelevant: { en: 'Irrelevant', nb: 'Irrelevant' },
  not_resolvable: { en: 'Not resolvable', nb: 'Kan ikke løses' },
  withdrawn: { en: 'Action withdrawn', nb: 'Handling trukket tilbake' },
  dismissed: { en: 'Dismissed', nb: 'Avvist' },
};
